import React from 'react';
import PropTypes from 'prop-types';

const Label = (props) => {
	const {text, ...rest} = props;

	return (
		<label {...rest}>{text}</label>
	);
};

Label.defaultProps = {};

Label.propTypes = {
	text: PropTypes.string.isRequired
};

export default Label;